export const DOWNLOAD_PINA_LINK = 'https://pina.onelink.me/6Kj9/cffaaa19';
export const APPSTORE_PINA_LINK = 'https://apps.apple.com/id/app/pina-plan-save-invest/id1591615968';
export const PLAYSTORE_PINA_LINK = 'https://play.google.com/store/apps/details?id=app.pina.id';